module.exports = __webpack_public_path__ + "img/8an-cat.f9bdacff.jpg";